import React, {useState} from 'react';
import LimitedTouchAreaButton from "./limitedTouchAreaButton";
import experimentState from "./state/experimentState";
import backend from "./backend";
import {observer} from "mobx-react";
import themeState from "./state/themeState";
import $ from "jquery";
import {mouseState, randomize_challenge} from "./state/mouseState";
import fakePointerRegister from "./state/fakePointerRegister";


class ChatRoomPanel extends React.Component {
    text_area_key = "chat_panel_text_area"

    constructor(props) {
        super(props);
        this.initialState = {
            message: "",
            shadowMessage: "Klik en hou je muis hier en begin met typen...",
            placeholder: true,
            is_challenge: false,
            has_typed: false,
        }
        this.state = this.initialState
        this.messageBuffer = []
        this.messageBufferPointer = 0;
        this.myRef = React.createRef();
        this.messageTickIntervalRef = null;
    }

    componentDidMount() {
        fakePointerRegister.register(this.text_area_key, this.fakeOnClick.bind(this))

    }

    componentWillUnmount() {
        fakePointerRegister.unregister(this.text_area_key)
    }

    handleMessageTick() {
        // console.log("Event: message tick!")
        this.messageBufferPointer += this.messageBufferPointer < this.messageBuffer.length - 1;
        this.setState({message: this.state.message, shadowMessage: this.messageBuffer[this.messageBufferPointer]})
        if (this.messageBufferPointer !== this.messageBuffer.length - 1) {
            this.messageTickIntervalRef = setTimeout(this.handleMessageTick.bind(this), themeState.chat_text_feedback)
        } else {
            this.messageTickIntervalRef = null;
        }
    }


    handleMessageChange(event) {
        // console.log("Event: message change!")
        this.messageBuffer.push(event.target.value)
        // console.log("Has typed before?", this.state.has_typed,experimentState.challengeState)
        if (!this.state.has_typed && experimentState.challengeState) {
            // We should trigger rendering of the challenge here.
            this.state.has_typed = true;
            // console.log("Enabling challenge", this.state.has_typed)
            experimentState.enableChallengeState()
        }
        this.setState({
            message: event.target.value,
            shadowMessage: this.state.placeholder ? "" : this.state.shadowMessage,
            placeholder: false,
            has_typed: this.state.has_typed,
            is_challenge: this.state.is_challenge,
        })
        if (!this.messageTickIntervalRef) {
            this.messageTickIntervalRef = setTimeout(this.handleMessageTick.bind(this), themeState.chat_text_feedback)
        }
        event.preventDefault()
    }

    handleSubmit(event) {
        if (this.state.message === "") {
            return;
        }
        backend.actionSendMessage(experimentState.user, this.state.message)
        this.setState(this.initialState)
        this.messageBuffer = []
        this.messageBufferPointer = 0
        if (this.messageTickIntervalRef) {
            clearTimeout(this.messageTickIntervalRef)
            this.messageTickIntervalRef = null;
        }

        experimentState.setPressedSend(true)

        // reset challenge
        if (experimentState.questionStart) {
            experimentState.setQuestionStart(null)
            // console.log(experimentState.questionExpired, experimentState.questionStart, experimentState.questionStart, (this.timeout * 1000), performance.now())
            backend.actionSendQuestionFinish(false)

            // We expect the user to move their mouse back, so we should set the lane correctly.
            // let rand = create(0)
            let transforms = randomize_challenge(null, false, true)
            mouseState.addTransform(transforms)

        }
        experimentState.resetChallengeState()

    }

    fakeOnClick(evt) {
        if (evt.type === "mousedown") {
            $(this.myRef.current).focus()
        }
    }

    render() {
        let divstyle = {
            cursor: themeState.cursor,
            resize: "none",
            height: "50px",
            width: "200px",
            padding: "5px",
            marginRight: "4px",
            borderRadius: "10px",
            position: "relative",
            top: "0px",
            left: "0px",
            gridArea: "inner-div",
            textAlign: "left",
            flexBasis: "auto",
            whiteSpace: "pre-wrap",
            // wordWrap: "break-word",
            wordBreak: "break-word",
        }
        return <form id="ChatPanelForm" onSubmit={fakePointerRegister.dud}
                     style={{
                         display: "flex",
                         justifyContent: "space-between",
                         flexDirection: themeState.rowDir[themeState.chat_panel_form_flex_direction],

                     }}>
            <div style={{display: "grid", placeItems: "center"}} id="textarea_wrapper">
                <textarea id="textarea" ref={this.myRef}
                          style={{
                              ...divstyle,
                              color: "transparent",
                              backgroundColor: "transparent",
                              whiteSpace: "preLine"
                          }}
                          onChange={this.handleMessageChange.bind(this)} value={this.state.message}></textarea>
                <pre
                    id={this.text_area_key}
                    style={{...divstyle, color: this.state.placeholder ? "gray" : "black", pointerEvents: "none"}}
                    onClick={fakePointerRegister.dud}>{this.state.shadowMessage}</pre>
            </div>
            {experimentState.experimentParams.admin ?
                <LimitedTouchAreaButton id="AdminSendNext" onClick={this.props.onAdminSendMessage}
                                        buttonText={this.props.finalQuestion ? "Finish" : "Next Question"}></LimitedTouchAreaButton> : ""}
            <LimitedTouchAreaButton id="ChatPanelSend" onClick={this.handleSubmit.bind(this)}/>
        </form>;
    }

}

ChatRoomPanel = observer(ChatRoomPanel);


export default ChatRoomPanel;